import { trackEvent } from 'user-analytics';

const PAYMENT_SCREEN = 'payment';
const SAVED_CARDS_SCREEN = 'payment';
const NO_SAVED_CARDS_SCREEN = 'payment';

function getRecurringDetail(card = {}) {
  return card.recurringDetail || {};
}

function getCardBrand(card = {}) {
  return card.brand || getRecurringDetail(card).variant;
}

export function isSavedCardExpired(card, now = new Date()) {
  if (typeof card.isExpired === 'boolean') return card.isExpired;

  const recurringDetail = getRecurringDetail(card);
  const cardDetails = recurringDetail.card || {};
  const month = Number(cardDetails.expiryMonth || cardDetails.expirationMonth);
  const year = Number(cardDetails.expiryYear || cardDetails.expirationYear);

  if (!month || !year) return false;

  const normalizedYear = year < 100 ? 2000 + year : year;
  return new Date(normalizedYear, month, 1) <= now;
}

export function trackSaveCardCheckboxClicked(enabled, hasSavedCards) {
  trackEvent('Save Card Checkbox Clicked', {
    'Screen': NO_SAVED_CARDS_SCREEN,
    'Enabled': enabled,
    'Has Saved Cards': Boolean(hasSavedCards),
  });
}

export function trackSavedCardSelected({ card, installmentsAvailable, position }) {
  trackEvent('Saved Card Selected', {
    'Screen': SAVED_CARDS_SCREEN,
    'Card Brand': getCardBrand(card),
    'Installments Available': Boolean(installmentsAvailable),
    'Position': position,
  });
}

export function trackAddNewCardButtonClicked(savedCardsCount) {
  trackEvent('Add New Card Button Clicked', {
    'Screen': SAVED_CARDS_SCREEN,
    'Saved Cards Count': savedCardsCount,
  });
}

export function trackSavedCardsViewed(cards = []) {
  trackEvent('Saved Cards Viewed', {
    'Screen': SAVED_CARDS_SCREEN,
    'Saved Cards Count': cards.length,
    'Expired Saved Cards Count': cards.filter((card) => isSavedCardExpired(card)).length,
  });
}

export function trackCardDeleteClicked(card) {
  trackEvent('Card Delete Clicked', {
    'Screen': PAYMENT_SCREEN,
    'Card Brand': getCardBrand(card),
    'Is Expired': isSavedCardExpired(card),
  });
}

export function trackCardDeleted(card, savedCardsCount) {
  trackEvent('Card Deleted', {
    'Screen': PAYMENT_SCREEN,
    'Card Brand': getCardBrand(card),
    'Is Expired': isSavedCardExpired(card),
    'Saved Cards Count': savedCardsCount,
  });
}

export function trackCardDeleteUndone() {
  trackEvent('Card Delete Undone', { Screen: PAYMENT_SCREEN });
}

export function trackSavedCardsModalOpened(cards = []) {
  trackEvent('Saved Cards Modal Opened', {
    'Screen': PAYMENT_SCREEN,
    'Saved Cards Count': cards.length,
    'Expired Saved Cards Count': cards.filter((card) => isSavedCardExpired(card)).length,
  });
}
